/**
 * 青岛鼎信-数据
 */
// 鼎信产品详情
import {icon1,icon2,icon3,report,report1,hetongJ1,hetongW1,hetongW2,hetongG1,hetongG2,hetongS1,hetongS2,hetongJ2,report2,report3} from './commonImg';

const p5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p5.png";
const p6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p6.png";
const p7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p7.png";
const p8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p8.png";
const p9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p9.png";
const p10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p10.png";
const p11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p11.png";
const p12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p12.png";
const p13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p13.png";
const p14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p14.png";
const p15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p15.png";
const p16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p16.png";
const p17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p17.png";
const p18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p18.png";
const p19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/detail/p19.png";
const dingxinJ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/dingxinJ1.png";
const dingxinS1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/dingxinS1.png";
//青岛鼎信
//资质证书
const dignxinImg = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dignxin.png";
const dingxinQ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ1.jpg";
const dingxinQ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ2.jpg";
const dingxinQ3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ3.jpg";
const dingxinQ4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ4.jpg";
const dingxinQ5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ5.jpg";
const dingxinQ6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ6.jpg";
const dingxinQ7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ7.jpg";
const dingxinQ8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinQ8.jpg";
//荣誉证书
const dingxinC1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC1.jpg";
const dingxinC2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC2.jpg";
const dingxinC3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC3.jpg";
const dingxinC4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC4.jpg";
const dingxinC5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC5.jpg";
const dingxinC6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC6.jpg";
const dingxinC7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC7.jpg";
const dingxinC8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC8.jpg";
const dingxinC9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC9.jpg";
const dingxinC10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC10.jpg";
const dingxinC11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC11.jpg";
const dingxinC12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC12.jpg";
const dingxinC13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC13.jpg";
const dingxinC14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC14.jpg";
const dingxinC15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC15.jpg";
const dingxinC16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC16.jpg";
const dingxinC17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC17.jpg";
const dingxinC18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC18.jpg";
const dingxinC19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC19.jpg";
const dingxinC20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC20.jpg";
const dingxinC21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC21.jpg";
const dingxinC22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC22.jpg";
const dingxinC23 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC23.jpg";
const dingxinC24 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC24.jpg";
const dingxinC25 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC25.jpg";
const dingxinC26 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC26.jpg";
const dingxinC27 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC27.jpg";
const dingxinC28 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC28.jpg";
const dingxinC29 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC29.jpg";
const dingxinC30 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dingxinC30.jpg";

const dingxinL1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL1.jpeg";
const dingxinL2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL2.png";
const dingxinL3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL3.png";
const dingxinL4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL4.png";
const dingxinL5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL5.png";
const dingxinL6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL6.png";
const dingxinL7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL7.png";
const dingxinL8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL8.png";
const dingxinL9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL9.png";
const dingxinL10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL10.png";
const dingxinL11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL11.png";
const dingxinL12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL12.png";
const dingxinL13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL13.png";
const dingxinL14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL14.png";
const dingxinL15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL15.png";
const dingxinL16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL14.png";
const dingxinL17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL17.png";
const dingxinL18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL18.png";
const dingxinL19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL19.png";
const dingxinL20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL20.png";
const dingxinL21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL21.png";
const dingxinL22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL22.png";
const dingxinL23 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL23.png";
const dingxinL24 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/dingxin/dingxinL24.png";

const dignxinCase1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/dignxin.png";
const dignxinPro1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/pro1.png";

const hetong1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetong1.png";
const hetong2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetong2.png";
const hetong3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetong3.png";
const hetong4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/hetong4.png";

const dingxinW1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/dingxinW1.png";


const dingxinG1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/case/dingxinG1.png";


const dx_banner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner.png";
const dx_banner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner1.jpg";
const dx_banner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner2.jpg";
const dx_banner4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner3.jpg";
// const dx_banner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner4.jpg"
const dx_banner6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner5.jpg";
const dx_banner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_banner.jpg";

const dx_logo = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/dx_logo.png";
export default {
    homeData: {
		herderBanner: [dx_banner1, dx_banner2, dx_banner3, dx_banner5, dx_banner4, dx_banner6],
		//企业logo
		// logo: 'http://firetopscomm.com/upload/image/20210329/1617010469288319.png',
		logo: dx_logo,
		//企业Vr背景
		vRlogo: dignxinImg,
		isShowVrModal: true,
		isShowVr: true,
		vRurl: "https://fs.m2.com.cn/home/20240171",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview:
			"青岛鼎信通讯消防安全有限公司是消防报警行业唯一A股主板上市企业（股票代码：603421），是中国领先的消防、电力等智能产品的高新技术企业，鼎信拥有36万平方米的生产基地以及1.3万平方米的研发中心，同时拥有CNAS认证的国家重点检测实验室，生产检测水平处于行业领先地位。 鼎信是消防报警全系统二线制的开创者与引领者，依托行业唯一自主研发芯片及TC-BUS通讯协议，创新性的实现了低功耗、智能化、全数字的全系统二线制，从芯片到模具，全系统产品均为自主研发生产，目前产品涵盖火灾报警、智能疏散、防火门监控、智慧消防系统等十三大系统，解决了民用建筑、公共建筑、工业厂房、车船隧道等多场景应用。公司于2017~2020年连续四年获得慧聪网消防行业品牌盛会“十大报警品牌”，于2018~2020年连续三年获得“中国房地产开发企业500强首选供应商”，于2018~2020年连续三年获得“中国房地产供应商竞争力评选竞争力十强”。",
		//公司官网
		website: "http://firetopscomm.com/",
		operatingStatus: "正常在业",
		//经营品类
		categories:
			"电子、机电、消防、计算机信息系统集成及软件产品的开发、生产、配套技术及售后服务；货物及技术进出口；配电开关控制设备及配件、火灾自动报警系统、照明电器、低压电器、灯具、应急灯、控制电源箱制造、加工、销售",
		//公司地址
		companyAddress: "山东省青岛市高新区华贯路858号",
		site: "山东省青岛市",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "10000万人民币",
		//成立日期
		establishment: "2014-06-25",
		//经营品牌
		brand: "鼎信",
		//主营产品
		mainProducts: "火灾报警控制器,紧急启停按钮,气体灭火控制器",
		//企业名称
		headerTitle: "青岛鼎信通讯消防安全有限公司",
		moreInfoName: "青岛鼎信",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: "1.现款现结,2.预付款,3.货到付款,4.按工程进度付款",
		//工厂地址
		factoryAddress: "青岛鼎信通讯消防安全有限公司",
		//工厂人数
		factoryHeadcount: "暂无信息",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "28000平方米",
		factoryHeadcount: "省市布局1-2个",
		capacity: "50亿元",
		annualOutputValue: "36万平方米",

		//联系负责人
		person: "杨松桦 先生 ",
		//联系电话
		contactNumber: "18053267070",
		//资质证书
		qualificationList: [
			{
				name: "营业执照",
				path: dingxinQ1,
			},
			{
				name: "绿色工厂证明",
				path: dingxinQ2,
			},
			{
				name: "2021年 采筑TUV供应商工厂认证证书",
				path: dingxinQ3,
			},
			{
				name: "CNAS认可证书",
				path: dingxinQ4,
			},
			{
				name: "企业信用等级证书",
				path: dingxinQ5,
			},
			{
				name: "环境管理体系认证证书",
				path: dingxinQ6,
			},
			{
				name: "职业健康安全管理体系认证证书",
				path: dingxinQ7,
			},
			{
				name: "质量管理体系认证证书",
				path: dingxinQ8,
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "2018年度中国房地产供应商竞争力十强",
				path: dingxinC1,
			},
			{
				name: "2018中国地产500强--首选供应商",
				path: dingxinC2,
			},
			{
				name: "2018中国房地产供应链上市公司投资潜力5强",
				path: dingxinC3,
			},
			{
				name: "2018年度碧桂园集团优秀新供方奖",
				path: dingxinC4,
			},
			{
				name: "2019年度中国房地产供应商竞争力十强（消防设备类）",
				path: dingxinC5,
			},
			{
				name: "2019中国地产500强--首选供应商",
				path: dingxinC6,
			},
			{
				name: "2020.8绿地控股核心供应商",
				path: dingxinC7,
			},
			{
				name: "2020年度创研优采黑科技大奖",
				path: dingxinC8,
			},
			{
				name: "2020年度中国房地产供应商竞争力十强",
				path: dingxinC9,
			},
			{
				name: "2020中国房地产开发企业500强首选供应商(前三甲)",
				path: dingxinC10,
			},
			{
				name: "2021.12 新希望2020-2021年A级合作商",
				path: dingxinC11,
			},
			{
				name: "2021中国地产500强--首选供应商",
				path: dingxinC12,
			},
			{
				name: "2021中国房地产开发企业综合实力top500首选供应商-消防设施类",
				path: dingxinC13,
			},
			{
				name: "2021中国房地产开发企业综合实力top500首选供应商-应急照明和疏散指示系统类",
				path: dingxinC14,
			},
			{
				name: "2022房地产开发企业综合实力TOP500首选供应商-消防设施类",
				path: dingxinC15,
			},
			{
				name: "2022房地产开发企业综合实力TOP500首选供应商-应急照明和疏散指示系统",
				path: dingxinC16,
			},
			{
				name: "2022年度中国房地产供应商竞争力十强",
				path: dingxinC17,
			},
			{
				name: "2022中国房地产开发企业综合实力TOP500首选供应商 应急照明和疏散指示系统",
				path: dingxinC18,
			},
			{
				name: "高新技术企业",
				path: dingxinC20,
			},
			{
				name: "慧聪网2017年十大报警品牌",
				path: dingxinC21,
			},
			{
				name: "慧聪网2018年十大报警品牌",
				path: dingxinC22,
			},
			{
				name: "慧聪网2019年十大报警品牌",
				path: dingxinC23,
			},
			{
				name: "慧聪网2020年十大报警品牌",
				path: dingxinC24,
			},
			{
				name: "慧聪网2021年十大报警品牌",
				path: dingxinC25,
			},
			{
				name: "中城联采第十二批联合采购长期合作伙伴",
				path: dingxinC26,
			},
			{
				name: "中城联盟绿色地产第九批联合采购长期合作伙伴",
				path: dingxinC27,
			},
			{
				name: "中城联盟绿色地产第十批联合采购长期合作伙伴",
				path: dingxinC28,
			},
			{
				name: "中城联盟绿色地产第十一批联合采购长期合作伙伴",
				path: dingxinC29,
			},
			{
				name: "中国消防协会证书",
				path: dingxinC30,
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "中国建筑第八工程局有限公司",
				path: "https://image.qcc.com/logo/df7ea3a61f721d6eabdfff8523c2b0f3.jpg?x-oss-process=style/logo_200",
				desc: "中建八局始建于1952年，企业发展经历了兵改工、工改兵的过程。1983年9月，由基建工程兵00229部队集体整编为中国建筑第八工程局，总部设于山东省济南市。1998年9月，为响应国家加快浦东开发的号召，局总部由山东济南迁入上海浦东。企业现有员工五万余人，下设六大分局，26家二级公司。主要经济技术指标名列中建排头。中建八局作为中国最具竞争力的大型综合投资建设集团，以承建“高、大、特、新、急”工程著称于世，重点发展高端房建、基础设施、地产开发、投资运营、创新业务 “五大业务板块”。形成了机场、会议会展、体育场馆、超高层、文化旅游、医疗卫生、高档酒店、商业综合体、工业厂房和公路、铁路、高铁站房、轨道交通、市政工程、水利水务等系列建筑产品。在国内外两个市场建成了一大,",
			},
			{
				name: "中国化学工程集团有限公司",
				path: "https://image.qcc.com/logo/ff4c267f4f04728f3f1636a42a640cf6.jpg?x-oss-process=style/logo_200",
				desc: "中国化学工程集团有限公司是国务院国资委直接监管的大型工程建设企业集团，是我国工业工程领域资质最为齐全、功能最为完备、业务链最为完整、知识技术相对密集的工程公司；是国内最早开展对外工程承包的企业之一。主要从事化工、石油化工、电力、市政、建筑、环保等工程建设、服务及相关业务,",
			},
			{
				name: "中国铁建股份有限公司",
				path: "https://image.qcc.com/logo/96e729177ef5fcc4dd92d72cd3babda8.jpg?x-oss-process=style/logo_200",
				desc: "中国铁建股份有限公司2007年11月5日在北京独家发起设立(中文简称中国铁建,英文简称CRCC),2008年3月10日、13日分别在上海和香港上市(A股代码601186、H股代码1186),公司注册资本135.8亿元。中国铁建是全球最具实力、规模的特大型综合建设集团之一,2021年《财富》“世界500强企业”排名第42位、“全球250家最大承包商”排名第3位、“中国企业500强”排名第12位。公司业务涵盖工程承包、规划设计咨询、投资运营、房地产开发、工业制造、物资物流、绿色环保、产业金融及其他新兴产业,经营范围遍及全国32个省、自治区、直辖市以及全球130多个国家和地区。已经从以施工承包为主发展成为具有科研、规划、勘察、设计、施工、监理、运营、维护和投融资完整的行业产业链,具备了为业主提供一站式综合服务的能力。在高原铁路、高速铁路、高速公路、桥梁、隧道和城市轨道交通工程设计及建设领域确立了行业领导地位。有1名工程院院士、11名国家勘察设计大师、11名“百千万人才工程”国家级人选和251名享受国务院特殊津贴的专家。累计获国家科学技术奖81项,中国土木工程詹天佑奖112项,国家优质工程奖444项,中国建筑工程鲁班奖148项,省部级工法3182项;累计拥有专利19072项。公司坚持新发展理念,遵循“实事求是、守正创新、行稳致远”的工作方针,以服务国家经济社会发展和满足人民对美好生活的向往为发展方向,围绕政府、城市和人作文章,倾力打造“品质铁建”,发挥全产业链优势,为客户提供一站式综合服务,向着最值得信赖的世界一流综合建设产业集团的企业愿景迈进。",
			},
			{
				name: "中国二十二冶集团有限公司",
				path: "https://image.qcc.com/logo/02b276c45630b311d284a6ec0c1512e9.jpg?x-oss-process=style/logo_200",
				desc: "中国二十二冶集团有限公司（简称中国二十二冶集团），原系中国第二十二冶金建设公司，隶属于中国冶金科工集团有限公司。中国二十二冶集团有限公司是以工程施工总承包、技术装备制造、资源开发、房地产开发为主营业务的综合性大型施工企业，并从事国际工程、设备租赁等相关业务，拥有对外经营权。具有房屋建筑、冶炼、市政公用工程总承包一级，机电设备安装、设备维修、地基与基础工程、钢结构、炉窑、管道工程专业承包一级资质和建筑工程甲级设计等多项资质。拥有适应工程建设需要的勘察、设计、科研机构和各类施工机械。拥有年产能力达35万吨的以生产工业与民用建筑钢结构产品为主的两座华北地区较大规模的现代化大型工业园，是中国钢结构协会授予的国家钢结构制造特级企业。从上世纪50年代以来，先后承建和参建了大批国家或地方的钢铁建设项目，房屋建筑、体育场馆和市政工程项目，以及建材、能源、化工、电力、交通、水利等行业的各类工程和国外许多工业与民用工程建设项目。其中，百余项工程分别获得国家建筑业鲁班奖和国家优质工程、全国用户满意工程、样板工程奖等。部分工程创全国同类工程最短工期施工纪录，主要建筑产品列入《中华之光名牌产品》大典。在祖国长城内外、大江南北铸就了座座丰碑。中国二十二冶集团有限公司人才荟萃、专业齐全、装备精良、技术先进、文化和谐，是国家钢结构工程技术研究中心制造分中心、河北省企业技术中心、省级重型装备预应力制造工程技术研究中心，建立了以企业技术为中心的创新体系；具有完整的质量保证体系和科学的管理制度，在全国同行业中率先通过质量、环境和职业安全健康管理体系认证。为全国“重合同、守信用”企业、中央企业先进集体、国家AAA级信用等级企业、建筑工程名牌企业、全国优秀施工企业、中国建筑业领先企业，并获得全国“五一”劳动奖状、全国精神文明先进单位、中国企业文化建设先进单位、国家技能人才培育突出贡献奖等荣誉称号。中国二十二冶集团有限公司在工程施工中，贯彻“奉献高质量的建筑产品是公司永恒追求”的质量方针，恪守“投标时为业主着想，施工时为业主负责，竣工时让业主满意”的质量承诺，在市场竞争中，树立了良好的企业形象和社会信誉。",
			},
			{
				name: "中国电力建设集团有限公司",
				path: "https://image.qcc.com/logo/2819ded6e92c42353ec9980a353275bf.jpg?x-oss-process=style/logo_200",
				desc: "中国电力建设集团有限公司（简称：中国电建）是经国务院批准，于2011年9月29日在中国水利水电建设集团公司、中国水电工程顾问集团公司和国家电网公司、中国南方电网有限责任公司所属的14个省（市、区）电力勘测设计、工程、装备制造企业基础上组建的国有独资公司。中国电建是全球能源电力、水资源与环境、基础设施及房地产领域提供全产业链集成、整体解决方案服务的综合性特大型建筑集团，主营业务横向跨越国内外能源电力、水利、铁路（地铁）、公路、机场、房屋建筑、水环境治理、市政基础设施及大土木、大建筑多行业，纵向覆盖投资开发、规划设计、工程承包、装备制造、项目运营等工程建设及运营全过程，具有懂水熟电的核心能力和产业链一体化的突出优势。此外，受国家有关部委委托，承担了国家水电、风电、太阳能等清洁能源和新能源的规划、审查等职能。电力建设（规划、设计、施工等）能力和业绩位居全球行业第一。",
			},
			{
				name: "广西建工集团有限责任公司",
				path: "https://image.qcc.com/logo/125760b2c110a779388e2ebce2faebc0.jpg?x-oss-process=style/logo_200",
				desc: "广西建工集团有限责任公司是广西壮族自治区国有大型企业，是自治区重点打造的“千亿元企业工程”企业，业务涵盖建筑施工与安装、房地产、建筑机械制造与租赁、混凝土、建材销售、基础设施投资、国际业务、矿业、酒店等板块，形成一业为主、多元并进的发展格局。",
			},
			{
				name: "万科地产",
				path: "https://image.qcc.com/logo/2f81f758b83cf35d1ebea5f822ebcab5.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "龙湖地产",
				path: "https://image.qcc.com/logo/h1ab50ba2132cac797688d838f4406a3.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "旭辉地产",
				path: "https://image.qcc.com/logo/b20e6f41d8cad8dab35485e04ddafa29.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "越秀地产",
				path: "https://image.qcc.com/logo/he814d83b986e9575f9933d9312ed2c2.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "建业地产",
				path: "https://image.qcc.com/logo/h1da9aded92fd90064f077b43f96a1b0.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "康桥地产",
				path: "https://image.qcc.com/logo/8c7e1e9475c1fae0d613724702ae8c5b.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
			{
				name: "保利地产",
				path: "https://image.qcc.com/logo/a57e8d579f81cbdf74c3486676b2c268.jpg?x-oss-process=style/logo_200",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 27,
				num: 0,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1127,
				num: 0,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "36亿+",
				num: 24,
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [
			{
				name: "陕西川百煜集成房屋有限公司",
				jumpParameter: "川百煜",
				site: "陕西省渭南市富平县庄里镇西上官村",
				path: "https://img.trustexporter.com/202112/23/083010562007719.png",
				capital: "人民币800万元",
				business:
					"建筑材料销售；集装箱制造；金属结构制造；五金产品零售；建筑装饰材料销售；卫生洁具销售；门窗销售；建筑防水卷材产品销售；集装箱销售；集装箱租赁服务",
			},
			{
				name: "浙江杭加泽通建筑节能新材料有限公司",
				jumpParameter: "杭加泽通",
				site: "浙江省杭州市富阳区渔山工业区",
				path: "https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=3218430523,254919849&fm=179&app=42&f=JPEG?w=300&h=300&s=4D261D72EB884CC85C5160D4000010B2",
				capital: "人民币60000万元元",
				business: "杭加alc板;ALC板材;增压加气混凝土板;AAC板;轻质隔墙板",
			},
		],
	},
    listData: {
		productList: [
			{ name: "点型光电感烟火灾探测器", img: dingxinL1 },
			{ name: "线型光束感烟火灾探测器", img: dingxinL2 },
			{ name: "吸气式感烟火灾探测器", img: dingxinL3 },
			{ name: "火灾显示盘", img: dingxinL4 },
			{ name: "隔离式安全栅", img: dingxinL21 },
			{ name: "火灾报警控制器/消防联动控制器", img: dingxinL22 },
			{ name: "图形显示装置", img: dingxinL23 },
			{ name: "消防广播音箱", img: dingxinL24 },
			{ name: "线型光束感烟火灾探测器反射器", img: dingxinL5 },
			{ name: "线型光束感烟火灾探测器支架", img: dingxinL6 },
			{ name: "缆式线型感温火灾探测器", img: dingxinL7 },
			{ name: "线型温度传感器探测器", img: dingxinL8 },
			{ name: "火灾声光警报器", img: dingxinL11 },
			{ name: "手动火灾报警按钮", img: dingxinL9 },
			{ name: "按钮通用底座", img: dingxinL10 },
			{ name: "点型探测器通用底座", img: dingxinL13 },
			{ name: "输入模块", img: dingxinL14 },
			{ name: "输入/输出模块底座", img: dingxinL15 },
			{ name: "总线隔离器", img: dingxinL16 },
			{ name: "总线中继器", img: dingxinL17 },
			{ name: "终端器", img: dingxinL18 },
			{ name: "火灾声光警报器底座", img: dingxinL12 },
			{ name: "模块通用底座", img: dingxinL19 },
			{ name: "点型光电感烟火灾探测器", img: dingxinL20 },

			{ name: "火灾报警控制器", img: p5 },
			{ name: "火灾报警控制器/消防联动控制器", img: dingxinL4 },
			{
				name: "火灾报警控制器/气体灭火控制器",
				img: p7,
			},
			{
				name: "消防应急广播设备",
				img: p8,
			},

			{
				name: "消防电话",
				img: p9,
			},

			{
				name: "剩余电流式电气火灾监控探测器",
				img: p10,
			},

			{
				name: "三相四线电压电流传感器",
				img: p11,
			},

			{
				name: "余压控制器",
				img: p12,
			},

			{
				name: "家用可燃气体探测器",
				img: p13,
			},

			{
				name: "一氧化碳探测器",
				img: p14,
			},

			{
				name: "点型探测器通用底座",
				img: p15,
			},

			{
				name: "压力变送器",
				img: p16,
			},

			{
				name: "防火门电动闭门器",
				img: p17,
			},

			{
				name: "集中电源集中控制型消防应急标志灯具",
				img: p18,
			},

			{
				name: "独立式光电感烟火灾探测报警器",
				img: p19,
			},
		],
		aim: "向高而生 向远而行",
		navList: [
			{
				name: "气体灭火控制系统",
				isShow: false,
				id: 1,
				children: ["点型光电感烟火灾探测器", "缆式线型感温火灾探测器", "火灾声光警报器"],
			},
			{
				name: "可燃气体探测报警系统",
				isShow: false,
				id: 2,
				children: ["火灾显示盘", "火灾声光警报器底座", "终端器"],
			},
			{
				name: "火灾自动报警及消防联动控制系统终端产品",
				isShow: false,
				id: 3,
				children: ["点型感温火灾探测器", "点型复合式感烟感温火灾探测器"],
			},

			{
				name: "火灾自动报警及消防联动控制系统控制器产品",
				isShow: false,
				children: ["火灾报警控制器", "火灾报警控制器/消防联动控制器"],
				id: 4,
			},

			{
				name: "气体灭火系统",
				isShow: false,
				children: ["火灾报警控制器/气体灭火控制器", "气体灭火控制器", "气体释放警报器"],
				id: 5,
			},

			{
				name: "消防应急广播系统",
				isShow: false,
				children: ["消防应急广播设备"],
				id: 6,
			},

			{
				name: "消防专用电话系统",
				isShow: false,
				children: ["消防电话", "消防电话插孔"],
				id: 7,
			},

			{
				name: "电气火灾监控系统",
				isShow: false,
				children: ["剩余电流式电气火灾监控探测器", "剩余电流式电气火灾监控探测器"],
				id: 8,
			},

			{
				name: "消防设备电源监控系统",
				isShow: false,
				children: ["三相四线电压电流传感器", "电流互感器"],
				id: 9,
			},

			{
				name: "消防余压监控系统",
				isShow: false,
				children: ["余压控制器", "余压探测器"],
				id: 10,
			},

			{
				name: "可燃气体探测报警系统",
				isShow: false,
				children: ["家用可燃气体探测器", "家用可燃气体探测器底座"],
				id: 11,
			},

			{
				name: "地下车库一氧化碳系统",
				isShow: false,
				children: ["一氧化碳探测器", "气体浓度监控器"],
				id: 12,
			},

			{
				name: "家用火灾报警系统",
				isShow: false,
				children: ["点型探测器通用底座", "手动报警开关"],
				id: 13,
			},

			{
				name: "消防水压监控系统",
				isShow: false,
				children: ["压力变送器", "消防水系统监控器"],
				id: 14,
			},

			{
				name: "防火门监控系统",
				isShow: false,
				children: ["防火门电动闭门器"],
				id: 3,
			},

			{
				name: "消防应急照明和疏散指示系统",
				isShow: false,
				children: ["集中电源集中控制型消防应急标志灯具"],
				id: 15,
			},

			{
				name: "家用智能产品",
				isShow: false,
				children: ["独立式光电感烟火灾探测报警器", "独立式光电感烟火灾探测报警器"],
				id: 16,
			},
		],
	},
    productDetailsData:	{
		点型光电感烟火灾探测器: {
			name: "点型光电感烟火灾探测器",
			img: dingxinL1,
			modelNumber: [
				{
					title: "JTY-GM-TS1011",
					img: dingxinL1,
				},
			],
			price: "272.985",
			detailImgs: [dingxinL1, dingxinL2, dingxinL3, dingxinL4],
			modelNumberText: "JTY-GM-TS1011",
			brand: "鼎信",
			describe: "编码型，指示灯360°可见，双向探测技术提升探测精度，PWM调制补偿技术，全新防护技术",
			report: [report, report1],
		},
		线型光束感烟火灾探测器: {
			name: "线型光束感烟火灾探测器",
			img: dingxinL2,
			modelNumber: [
				{
					title: "JTY-HS-TS1006",
					img: dingxinL2,
				},
			],
			price: "272.985",
			detailImgs: [dingxinL2, dingxinL1, dingxinL3, dingxinL4],
			modelNumberText: "JTY-HS-TS1006",
			brand: "鼎信",
			describe: "编码型，光路长度10m~100m，含1只反射器",
			report: [report2, report3],
		},
		吸气式感烟火灾探测器: {
			name: "吸气式感烟火灾探测器",
			img: dingxinL3,
			modelNumber: [
				{
					title: "JTY-GM-TS1011",
					img: dingxinL3,
				},
			],
			price: "272.985",
			detailImgs: [dingxinL3, dingxinL2, dingxinL1, dingxinL4],
			modelNumberText: "JTY-GM-TS1011",
			brand: "鼎信",
			describe: "编码型，指示灯360°可见，双向探测技术提升探测精度，PWM调制补偿技术，全新防护技术",
			report: [report2, report3],
		},
		火灾显示盘: {
			name: "火灾显示盘",
			img: dingxinL4,
			modelNumber: [
				{
					title: "JTY-GM-TS1011",
					img: dingxinL4,
				},
			],
			price: "272.985",
			detailImgs: [dingxinL4, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "JTY-GM-TS1011",
			brand: "鼎信",
			describe: "编码型，指示灯360°可见，双向探测技术提升探测精度，PWM调制补偿技术，全新防护技术",
			report: [report2, report3],
		},
		隔离式安全栅: {
			name: "隔离式安全栅",
			img: dingxinL21,
			modelNumber: [
				{
					title: "TS-AS-100",
					img: dingxinL21,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL21, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-AS-100",
			brand: "鼎信",
			describe: "编码型",
			report: [report2, report3],
		},
		"火灾报警控制器/消防联动控制器": {
			name: "火灾报警控制器/消防联动控制器",
			img: dingxinL22,
			modelNumber: [
				{
					title: "JB-QB-TS200N/64",
					img: dingxinL22,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL22, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "JB-QB-TS200N/64",
			brand: "鼎信",
			describe:
				"壁挂式，彩色液晶屏，可接入64个设备，超宽范围工作电压，具有TTS语音播报功能，内置浪涌保护器，含1块30键总线盘，含1块9路直控盘，含打印机，含5Ah/12V蓄电池1节",
			report: [report2, report3],
		},
		图形显示装置: {
			name: "图形显示装置",
			img: dingxinL23,
			modelNumber: [
				{
					title: "TS-XS-8001",
					img: dingxinL23,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL23, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-XS-8001",
			brand: "鼎信",
			describe:
				"一体化设计，琴台式，含琴台，采用Cortex-A9 架构，嵌入式LINUX平台，18.5英寸TFT-LCD液晶显示屏，具备RS232、RS485、USB、HDMI 等接口/12V蓄电池1节",
			report: [report2, report3],
		},
		消防广播音箱: {
			name: "消防广播音箱",
			img: dingxinL24,
			modelNumber: [
				{
					title: "YJ04-0501",
					img: dingxinL24,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL24, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "YJ04-0501",
			brand: "鼎信",
			describe: "圆形，嵌入吸顶式，额定功率3W，外形尺寸φ189mm×69.5mm",
			report: [report2, report3],
		},
		线型光束感烟火灾探测器反射器: {
			name: "线型光束感烟火灾探测器反射器",
			img: dingxinL5,
			modelNumber: [
				{
					title: "1006-FSQ",
					img: dingxinL5,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL5, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "1006-FSQ",
			brand: "鼎信",
			describe: "与线型光束感烟火灾探测器配套使用，安装距离为40m-100m时，需安装4只反射器",
			report: [report2, report3],
		},
		线型光束感烟火灾探测器支架: {
			name: "线型光束感烟火灾探测器支架",
			img: dingxinL6,
			modelNumber: [
				{
					title: "1006-ZJ",
					img: dingxinL6,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL6, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "1006-ZJ",
			brand: "鼎信",
			describe: "线型光束感烟火灾探测器安装支架",
			report: [report2, report3],
		},
		缆式线型感温火灾探测器: {
			name: "缆式线型感温火灾探测器",
			img: dingxinL7,
			modelNumber: [
				{
					title: "JTW-LD-TS1008F/85",
					img: dingxinL7,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL7, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "JTW-LD-TS1008F/85",
			brand: "鼎信",
			describe: "编码型，与85℃线型温度传感器配套使用，最长可带载200m线型温度传感器",
			report: [report2, report3],
		},
		线型温度传感器探测器: {
			name: "线型温度传感器探测器",
			img: dingxinL8,
			modelNumber: [
				{
					title: "JTW-LD-TS1008F/105X",
					img: dingxinL8,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL8, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "JTW-LD-TS1008F/105X",
			brand: "鼎信",
			describe: "可恢复型，普通型，报警温度：105℃，与缆式线型感温火灾探测器配套使用",
			report: [report2, report3],
		},
		手动火灾报警按钮: {
			name: "手动火灾报警按钮",
			img: dingxinL9,
			modelNumber: [
				{
					title: "J-SAP-TS2011",
					img: dingxinL9,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL9, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "J-SAP-TS2011",
			brand: "鼎信",
			describe: "编码型，不带电话插孔，全新防护技术，独立输出触点，报警上传时间小于1s",
			report: [report2, report3],
		},
		按钮通用底座: {
			name: "按钮通用底座",
			img: dingxinL10,
			modelNumber: [
				{
					title: "TS-DZ-1404",
					img: dingxinL10,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL10, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-DZ-1404",
			brand: "鼎信",
			describe: "手动火灾报警按钮、消火栓按钮通用底座，插拔式结构，采用专利免剥线技术",
			report: [report2, report3],
		},
		火灾声光警报器: {
			name: "火灾声光警报器",
			img: dingxinL11,
			modelNumber: [
				{
					title: "TS-SG-2101N",
					img: dingxinL11,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL11, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-SG-2101N",
			brand: "鼎信",
			describe: "编码型，3种报警方式，2种报警声调，可设置为非编码声光，白光，免剥线接线方式，卡扣式安装",
			report: [report2, report3],
		},
		点型探测器通用底座: {
			name: "点型探测器通用底座",
			img: dingxinL13,
			modelNumber: [
				{
					title: "TS-DZ-1403",
					img: dingxinL13,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL13, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-DZ-1403",
			brand: "鼎信",
			describe: "编码型探测器通用底座",
			report: [report2, report3],
		},
		输入模块: {
			name: "输入模块",
			img: dingxinL14,
			modelNumber: [
				{
					title: "TS-SR-2201",
					img: dingxinL14,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL14, dingxinL2, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-SR-2201",
			brand: "鼎信",
			describe: "编码型，无源信号输入，与通用底座TS-DZ-1422配套使用",
			report: [report2, report3],
		},
		"输入/输出模块底座": {
			name: "输入/输出模块底座",
			img: dingxinL15,
			modelNumber: [
				{
					title: "TS-RC-2204/D",
					img: dingxinL15,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL15, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-RC-2204/D",
			brand: "鼎信",
			describe: "与2204输入/输出模块配套使用，插拔式结构，压线螺钉采用防脱设计",
			report: [report2, report3],
		},
		总线隔离器: {
			name: "总线隔离器",
			img: dingxinL16,
			modelNumber: [
				{
					title: "TS-GL-9202",
					img: dingxinL16,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL16, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-GL-9202",
			brand: "鼎信",
			describe: "非编码型，故障排除后自恢复，150mA/300mA两级保护电流自动配置，与通用底座TS-DZ-1422配套使用",
			report: [report2, report3],
		},
		总线中继器: {
			name: "总线中继器",
			img: dingxinL17,
			modelNumber: [
				{
					title: "TS-ZJ-9303",
					img: dingxinL17,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL17, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-ZJ-9303",
			brand: "鼎信",
			describe: "编码型，24V电源供电，增强信号强度，提高总线带载能力，输出电流0.6A",
			report: [report2, report3],
		},
		终端器: {
			name: "终端器",
			img: dingxinL18,
			modelNumber: [
				{
					title: "TS-ZD-6402",
					img: dingxinL18,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL18, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-ZD-6402",
			brand: "鼎信",
			describe: "非编码型，安装于线路末端，提高总线通讯质量",
			report: [report2, report3],
		},
		火灾声光警报器底座: {
			name: "火灾声光警报器底座",
			img: dingxinL12,
			modelNumber: [
				{
					title: "TS-SG-2101N/D",
					img: dingxinL12,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL12, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-SG-2101N/D",
			brand: "鼎信",
			describe: "与2101N、2106火灾声光警报器配套使用",
			report: [report2, report3],
		},
		模块通用底座: {
			name: "模块通用底座",
			img: dingxinL19,
			modelNumber: [
				{
					title: "TS-DZ-1422",
					img: dingxinL19,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL19, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "TS-DZ-1422",
			brand: "鼎信",
			describe: "模块通用底座，插拔式结构",
			report: [report2, report3],
		},
		点型光电感烟火灾探测器: {
			name: "点型光电感烟火灾探测器",
			img: dingxinL20,
			modelNumber: [
				{
					title: "JTYB-GM-TS1001(Ex)",
					img: dingxinL20,
				},
			],
			price: "暂无",
			detailImgs: [dingxinL20, dingxinL8, dingxinL3, dingxinL1, dingxinL13, dingxinL11],
			modelNumberText: "JTYB-GM-TS1001(Ex)",
			brand: "鼎信",
			describe:
				"本质安全型，防爆标志为ExibⅡCT6，编码型，指示灯360°可见，平衡黑白烟灵敏度，PWM调制补偿技术，与本安探测器底座TS-DZ-1401(Ex)配套使用",
			report: [report2, report3],
		},

		火灾报警控制器: {
			name: "火灾报警控制器",
			img: p5,
			modelNumber: [
				{
					title: "JB-QB-TS100N",
					img: p5,
				},
			],
			price: "272.985",
			detailImgs: [p5, dingxinL2, dingxinL3, dingxinL1],

			modelNumberText: "规格型号:JB-QB-TS100N",
			report: [report2, report3],
			brand: "鼎信",
		},

		"火灾报警控制器/消防联动控制器": {
			name: "火灾报警控制器/消防联动控制器",
			img: p6,
			modelNumber: [
				{
					title: "JB-QB-TS200N/64",
					img: p6,
				},
			],
			price: "272.985",
			detailImgs: [p6, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:JB-QB-TS200N/64",
		},

		"火灾报警控制器/气体灭火控制器": {
			name: "火灾报警控制器/气体灭火控制器",
			img: p7,
			modelNumber: [
				{
					title: "JB-QB-TS128/TS-MH-5001",
					img: p7,
				},
			],
			price: "272.985",
			detailImgs: [p7, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:JB-QB-TS128/TS-MH-5001",
		},

		消防应急广播设备: {
			name: "消防应急广播设备",
			img: p8,
			modelNumber: [
				{
					title: "TS-XG1000/A",
					img: p8,
				},
			],
			price: "272.985",
			detailImgs: [p8, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:TS-XG1000/A",
		},

		消防电话: {
			name: "消防电话",
			img: p9,
			modelNumber: [
				{
					title: "TS-DZ-6002",
					img: p9,
				},
			],
			price: "272.985",
			detailImgs: [p9, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:TS-DZ-6002",
		},

		剩余电流式电气火灾监控探测器: {
			name: "剩余电流式电气火灾监控探测器",
			img: p10,
			modelNumber: [
				{
					title: "TS-DH-1645",
					img: p10,
				},
			],
			price: "272.985",
			detailImgs: [p10, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:TS-DH-1645",
		},

		三相四线电压电流传感器: {
			name: "三相四线电压电流传感器",
			img: p11,
			modelNumber: [
				{
					title: "TS-DJ-1933",
					img: p11,
				},
			],
			price: "272.985",
			detailImgs: [p11, dingxinL2, dingxinL3, dingxinL1],
			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:TS-DJ-1933",
		},

		余压控制器: {
			name: "余压控制器",
			img: p12,
			modelNumber: [
				{
					title: "TS-YK-100",
					img: p12,
				},
			],
			price: "272.985",
			detailImgs: [p12, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:TS-YK-100",
			report: [report2, report3],
			brand: "鼎信",
		},

		家用可燃气体探测器: {
			name: "家用可燃气体探测器",
			img: p13,
			modelNumber: [
				{
					title: "JT-TS1105",
					img: p13,
				},
			],
			price: "272.985",
			detailImgs: [p13, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:JT-TS1105",

			report: [report2, report3],
			brand: "鼎信",
		},

		一氧化碳探测器: {
			name: "一氧化碳探测器",
			img: p14,
			modelNumber: [
				{
					title: "JM-TS1107",
					img: p14,
				},
			],
			price: "272.985",
			detailImgs: [p14, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:JM-TS1107",

			report: [report2, report3],
			brand: "鼎信",
		},

		点型探测器通用底座: {
			name: "点型探测器通用底座",
			img: p15,
			modelNumber: [
				{
					title: "TS-DZ-1401",
					img: p15,
				},
			],
			price: "272.985",
			detailImgs: [p15, dingxinL2, dingxinL3, dingxinL1],

			report: [report2, report3],
			brand: "鼎信",
			modelNumberText: "规格型号:TS-DZ-1401",
		},

		压力变送器: {
			name: "压力变送器",
			img: p16,
			modelNumber: [
				{
					title: "CYYZ11-H-13-A1-14-B-G",
					img: p16,
				},
			],
			price: "272.985",
			detailImgs: [p16, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:CYYZ11-H-13-A1-14-B-G",

			report: [report2, report3],
			brand: "鼎信",
		},

		防火门电动闭门器: {
			name: "防火门电动闭门器",
			img: p17,
			modelNumber: [
				{
					title: "TS-DM-2607/65",
					img: p17,
				},
			],
			price: "272.985",
			detailImgs: [p17, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:TS-DM-2607/65",

			report: [report2, report3],
			brand: "鼎信",
		},

		集中电源集中控制型消防应急标志灯具: {
			name: "集中电源集中控制型消防应急标志灯具",
			img: p18,
			modelNumber: [
				{
					title: "TS-BLJC-1LREⅡ0.5W-B001M",
					img: p18,
				},
			],
			price: "272.985",
			detailImgs: [p18, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:TS-BLJC-1LREⅡ0.5W-B001M",

			report: [report2, report3],
			brand: "鼎信",
		},

		独立式光电感烟火灾探测报警器: {
			name: "独立式光电感烟火灾探测报警器",
			img: p19,
			modelNumber: [
				{
					title: "JTY-GF-TS1203/NB-IOT（电信）",
					img: p19,
				},
			],
			price: "272.985",
			detailImgs: [p19, dingxinL2, dingxinL3, dingxinL1],
			modelNumberText: "规格型号:JTY-GF-TS1203/NB-IOT（电信）",

			report: [report2, report3],
			brand: "鼎信",
		},
	},
    contactListData: {
		list: [
			{
				name: "杨松桦",
				position: "销售",
				id: "1",
				phoneNum: "18053267070",
				color: "#23B095 ",
				telephone: "4009686119",
				email: "yangsonghua@topscomm.com",
			},
			{
				name: "售后客服电话",
				position: "客服",
				id: "2",
				phoneNum: "4009686119",
				color: "#23B095 ",
				telephone: "4009686119",
				email: "",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "拉林铁路项目",
				id: 1,
				price: "320万",
				time: "2020",
				site: "西藏",
				type: "铁路",
				unit: "成都四为电子信息股份有限公司",
				desc: "拉林铁路起自西藏自治区拉萨市，终至林芝市区，是西藏地区首条电气化铁路，全长435.48公里，线路90%以上的线路在海拔3000米以上，16次跨越雅鲁藏布江，沿线山高谷深，相对高差达2500米。全线共建设隧道47座，总长度216.5公里，占线路总长54%，项目所在地自然条件恶劣，昼夜温差大，常年风沙天气。正式通车后总书记坐上专列实地察看拉林铁路沿线建设情况，",
				imgList: [{ title: "", path: dignxinCase1 }],
				proImgList: [{ title: "", path: dignxinPro1 }],
				contractList: [
					{ title: "", path: hetong1 },
					{ title: "", path: hetong2 },
					{ title: "", path: hetong3 },
				],
				product: "点型光电感烟探测器、消防应急照明灯等消防报警设备",
			},
			{
				name: "乌鲁木齐国际机场",
				id: 2,
				price: "100万",
				time: "2022",
				site: "新疆乌鲁木齐",
				type: "机场",
				unit: "库车飞驰消防有限公司",
				desc: "乌鲁木齐国际机场新建T4 航站楼，包含50万平方米的北区航站楼和34.5万平方米的交通中心。改扩建完成后，乌鲁木齐国际机场飞行区等级将达到最高等级4F(最高级)，同时也是新疆最大的单体建筑。鼎信消防提供全系统消防报警解决方案，打破外资品牌垄断，是国内首家为4F 级机场提供国产消防报警解决方案的供应商",
				imgList: [{ title: "", path: dingxinW1 }],
				proImgList: [{ title: "", path: dingxinW1 }],
				contractList: [
					{ title: "", path: hetongW1 },
					{ title: "", path: hetongW2 },
				],
				product: "点型光电感烟探测器、消防应急照明灯等消防报警设备",
			},
			{
				name: "贵港高铁站",
				id: 3,
				price: "128万",
				time: "2020",
				site: "广西壮族自治区贵港市",
				type: "高铁",
				unit: "广西长二千建材有限公司",
				desc: "贵港站位于中国广西壮族自治区贵港市,是中国铁路南宁局集团有限公司玉林车务段管辖为一等客货站，是南广铁路和黎湛铁路的枢纽站。进站大厅面积2340平方米，两层候车室面积共9222平方米",
				imgList: [{ title: "", path: dingxinG1 }],
				proImgList: [{ title: "", path: dingxinG1 }],

				contractList: [
					{ title: "", path: hetongG1 },
					{ title: "", path: hetongG2 },
				],
				product: "点型光电感烟探测器、消防应急照明灯等消防报警设备",
			},
			{
				name: "齐鲁医科大学济南主校区项目一期",
				id: 3,
				price: "",
				time: "2020",
				site: "山东省济南市",
				type: "学校",
				unit: "中建八局第二建设有限公司",
				desc: "项目为项目面积2000000平方米，总建筑面积为905040平方米",
				imgList: [{ title: "", path: dingxinS1 }],
				proImgList: [{ title: "", path: dingxinS1 }],
				contractList: [
					{ title: "", path: hetongS1 },
					{ title: "", path: hetongS2 },
				],
				product: "点型光电感烟探测器、消防应急照明灯等消防报警设备",
			},
			{
				name: "扬州华侨城项目A地块",
				id: 3,
				price: "",
				time: "2022",
				site: "江苏省扬州市",
				type: "住宅",
				unit: "扬州华侨城实业发展有限公司",
				desc: "邗江东至瘦西湖路、西至侨城路、南至学士路、北至侨香路",
				imgList: [{ title: "", path: dingxinJ1 }],
				proImgList: [{ title: "", path: dingxinJ1 }],
				contractList: [
					{ title: "", path: hetongJ1 },
					{ title: "", path: hetongJ2 },
				],
				product: "点型光电感烟探测器、消防应急照明灯等消防报警设备",
			},
		],
	},
    evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 20,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: true,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${14}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: '万科20年合格供应商',
				subtitle: "万科20年合格供应商",
				isShow: true,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				// title: '百强地产合作',
				subtitle: "百强地产合作",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${7}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${7}.png`,
				// title: '百强地产合作',
				subtitle: "发明专利",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${12}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${12}.png`,
				// title: '百强地产合作',
				subtitle: "国家认可实验室",
				isShow: true,
			},

			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${14}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
			//     title: '建筑领域',
			//     subtitle: '管理体系认证',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${10}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${10}.png`,
			//     title: 'ISO',
			//     subtitle: '三体系认证',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
			//     title: '建筑',
			//     subtitle: '老牌企业',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${11}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${11}.png`,
			//     title: '财务稳健',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${8}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${8}.png`,
			//     title: 'AAA',
			//     subtitle: '银行信用',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${13}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${13}.png`,
			//     title: '第三方',
			//     subtitle: '优质平价',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${6}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${6}.png`,
			//     title: '生产基地',
			//     subtitle: '审查',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${4}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${4}.png`,
			//     title: '生产基地',
			//     subtitle: '面积',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${5}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${5}.png`,
			//     title: '年产量',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${7}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${7}.png`,
			//     title: '专利证书',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${12}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${12}.png`,
			//     title: '参编',
			//     subtitle: '技术标准',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${9}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${9}.png`,
			//     title: 'CNAS',
			//     subtitle: '实验室认证',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${2}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${2}.png`,
			//     title: '绿色认证',
			//     isShow: false

			// },
			// {
			//     hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${3}.png`,
			//     grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${3}.png`,
			//     title: '绿色制造',
			//     isShow: false
			// },
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "2022-2024年度新虹联消防报警战略联采",
				name2: "2022-2024年度新虹联消防报警战略联采",
				name3: "物资采购",
				date: "2022/6/30",
			},
			{
				name1: "建工八建-天津分公司-石家庄龙湖天璞-普通灯具开关插座任务",
				name2: "石家庄龙湖天璞项目1标段总承包工程",
				name3: "物资采购",
				date: "2022/6/28",
			},
			{
				name1: "济南济齐路君逸府项目（应急电箱及灯具）",
				name2: "济南济齐路君逸府项目（应急电箱及灯具）询价项目",
				name3: "物资采购",
				date: "2021/12/2",
			},
			{
				name1: "天健地产集团2021-2023年度消防报警设备战略采购",
				name2: "天健地产集团2021-2023年度消防报警设备战略采购",
				name3: "物资采购",
				date: "2021/10/11",
			},
			{
				name1: "华西上海公司安装南京复地项目消防系统设备采购",
				name2: "华西上海公司安装南京复地项目消防系统设备采购",
				name3: "物资采购",
				date: "2021/8/25",
			},
			{
				name1: "天健地产集团2021-2023年度消防报警设备战略采购",
				name2: "天健地产集团2021-2023年度消防报警设备战略采购",
				name3: "物资采购",
				date: "2021/7/17",
			},
			{
				name1: "阜南安建-淮畔世家项目(消防报警设备)采购招标",
				name2: "阜南安建-淮畔世家项目",
				name3: "物资采购",
				date: "2019/4/24",
			},
		],
	},
    lawData: {
		info: [
			{
				caseName: "青岛鼎信通讯消防安全有限公司",
				reference: "青岛鼎信通讯消防安全有限公司",
				cause: "合同纠纷",
				identity: "申请执行人",
				caseType: "原告",
				date: "2021-12-30",
			},
		],
	},
    tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立5年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
}